module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-Bold.75592b2.ttf";